import { Routes, Route } from 'react-router-dom';
import { PageNotFound } from 'br2s-ui-common-utils-02';
import { CRM_ROUTES } from '@/utilities/constants/constants';
import { ErrorHandler } from '@/components/ErrorHandler/ErrorHandler';
import 'br2s-ui-componentlibrary_r2_02/dist/foundation/foundation.scss';
import {
  CRMClarificationForm,
  CRMFeedbackForm,
  CRMInputForm,
  CRMSurveyForm,
  CRMSurveyUnsubscriptionForm,
} from '@/pages/crm';
import CRMLayout from '@/layouts/CRMLayout/CRMLayout';

function CrmModule() {
  return (
    <ErrorHandler type='inline'>
      <Routes>
        <Route element={<CRMLayout />}>
          <Route
            path={CRM_ROUTES.CLARIFICATION}
            element={<CRMClarificationForm />}
          />
          <Route path={CRM_ROUTES.INPUT} element={<CRMInputForm />} />
          <Route path={CRM_ROUTES.FEEDBACK} element={<CRMFeedbackForm />} />
          <Route path={CRM_ROUTES.SURVEY} element={<CRMSurveyForm />} />
          <Route
            path={CRM_ROUTES.SURVEY_UNSUB}
            element={<CRMSurveyUnsubscriptionForm />}
          />
        </Route>
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </ErrorHandler>
  );
}

export default CrmModule;
